'use strict';
module.exports = require('../../full/object/iterate-entries');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/iterate-entries.js
// module id = 352
// module chunks = 0